/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess202,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess.ts";
import { courseRegistrationSaveCourseAccessRequestViewModelSchema } from "../courseRegistrationSaveCourseAccessRequestViewModelSchema.ts";

export const putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess202Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess500>;

export const putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequestSchema =
  z.lazy(
    () => courseRegistrationSaveCourseAccessRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationRequest>;

export const putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponseSchema =
  z.lazy(
    () =>
      putApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccess202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessMutationResponse>;
